import React, { Component } from 'react';
import styles from './RadioBox.module.css';
import { restructureResponse } from '../../helpers/sparql';

class RadioBox extends Component {
  componentDidMount() {
    let options = this.restructureOptions();
    if (!options) return;

    this.props.publish(this.props.publishVariable, options[0] && options[0].value);
  }

  onChange = event => {
    let value = event.target.value;
    console.log(value);
    this.props.publish(this.props.publishVariable, value);
  };

  restructureOptions() {
    let options = this.props.options;
    try {
      options = options.split(',');
    } catch (error) {
      return null;
    }

    options = options.reduce((org, value, index) => {
      if (index % 2 === 0) {
        value = value.trim();
        org = [
          ...org,
          {
            value,
            label: options[index + 1] || value
          }
        ];
      }
      return org;
    }, []);
    return options;
  }

  renderOptions() {
    let value = this.props.pubsub[this.props.publishVariable];
    let options = this.restructureOptions();

    if (!options) {
      return <div>Options should be a comma separated list of value,label pairs</div>;
    }

    return (
      <div>
        {options.map(option => (
          <div key={option.value}>
            <label className={styles.radioContainer}>
              <input
                type="radio"
                name={this.props.label}
                checked={value === option.value}
                value={option.value}
                onChange={this.onChange}
              />
              <span style={{ verticalAlign: 'middle', paddingLeft: '12px' }}>{option.label}</span>
            </label>
          </div>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className={styles.main}>
        <div className={styles.label}>{this.props.label}</div>
        {this.renderOptions()}
      </div>
    );
  }
}

export default RadioBox;
